// ATECO codes most relevant for M&A targeting in Italy
// Grouped by investment theme
export const ATECO_CATEGORIES = [
  {
    group: "Industrial / Manufacturing",
    items: [
      { code: "25.99", label: "Lavorazioni meccaniche / Prodotti metallici specializzati" },
      { code: "28.22", label: "Macchinari industriali — sollevamento e movimentazione" },
      { code: "28.41", label: "Macchine utensili per lavorazione metalli" },
      { code: "28.49", label: "Macchine utensili altre (legno, pietra, vetro)" },
      { code: "28.92", label: "Macchine per estrazione/cantieri" },
      { code: "29.32", label: "Componentistica automotive (sub-fornitura)" },
      { code: "30.30", label: "Aerospazio e difesa — componenti" },
      { code: "22.29", label: "Packaging plastico industriale" },
    ],
  },
  {
    group: "Food & Beverage",
    items: [
      { code: "10.11", label: "Lavorazione carni (salumi, catena del freddo)" },
      { code: "10.51", label: "Latticini e formaggi" },
      { code: "10.71", label: "Pasticceria e prodotti da forno" },
      { code: "10.85", label: "Piatti pronti / ready-to-eat" },
      { code: "10.89", label: "Specialty food / prodotti artigianali" },
      { code: "11.02", label: "Vino — cantine e vinificazione" },
    ],
  },
  {
    group: "Technology / SaaS",
    items: [
      { code: "62.01", label: "Sviluppo software (B2B SaaS, custom)" },
      { code: "62.02", label: "Consulenza IT e system integration" },
      { code: "62.09", label: "Altri servizi IT (cloud, cybersecurity)" },
      { code: "63.11", label: "Hosting, data processing, colocation" },
      { code: "58.29", label: "Software packaged (vertical SaaS)" },
    ],
  },
  {
    group: "Healthcare / Pharma",
    items: [
      { code: "21.10", label: "Principi attivi farmaceutici (API)" },
      { code: "21.20", label: "Farmaci finiti (specialty pharma)" },
      { code: "32.50", label: "Dispositivi medici" },
      { code: "86.90", label: "Servizi sanitari specialistici (laboratori, cliniche)" },
      { code: "87.10", label: "Residenze sanitarie assistenziali (RSA)" },
    ],
  },
  {
    group: "Consumer / Luxury",
    items: [
      { code: "14.13", label: "Abbigliamento lusso (confezioni esterne)" },
      { code: "15.20", label: "Calzature lusso / artigianali" },
      { code: "15.12", label: "Pelletteria artigianale" },
      { code: "32.12", label: "Gioielleria e oreficeria" },
      { code: "31.09", label: "Mobili di design / arredi" },
    ],
  },
  {
    group: "Services / B2B",
    items: [
      { code: "70.22", label: "Consulenza strategica / management" },
      { code: "71.12", label: "Ingegneria e progettazione" },
      { code: "78.20", label: "Staffing / somministrazione lavoro" },
      { code: "82.20", label: "Call center / customer service" },
    ],
  },
  {
    group: "Energy / CleanTech",
    items: [
      { code: "35.11", label: "Produzione energia elettrica (rinnovabili)" },
      { code: "38.11", label: "Gestione rifiuti non pericolosi" },
      { code: "38.32", label: "Recupero materiali / economia circolare" },
      { code: "43.21", label: "Installazioni elettriche / EV charging" },
    ],
  },
  {
    group: "Logistics / Real Estate",
    items: [
      { code: "49.41", label: "Trasporto merci su strada" },
      { code: "52.10", label: "Magazzinaggio e logistica (3PL)" },
      { code: "52.29", label: "Spedizioni internazionali" },
      { code: "68.20", label: "Locazione immobili (real estate)" },
    ],
  },
];

// Italian provinces (sigle)
export const PROVINCE = [
  "AG","AL","AN","AO","AP","AQ","AR","AT","AV","BA","BG","BI","BL","BN","BO","BR","BS","BT","BZ","CA",
  "CB","CE","CH","CL","CN","CO","CR","CS","CT","CZ","EN","FC","FE","FG","FI","FM","FR","GE","GO","GR",
  "IM","IS","KR","LC","LE","LI","LO","LT","LU","MB","MC","ME","MI","MN","MO","MS","MT","NA","NO","NU",
  "OR","PA","PC","PD","PE","PG","PI","PN","PO","PR","PT","PU","PV","PZ","RA","RC","RE","RG","RI","RM",
  "RN","RO","SA","SI","SO","SP","SR","SS","SU","SV","TA","TE","TN","TO","TP","TR","TS","TV","UD","VA",
  "VB","VC","VE","VI","VR","VT","VV",
];
